import {
  Box, Card, CardContent, TextField, Button, Typography, Alert, MenuItem, Link,
} from '@mui/material';
import { PointOfSale } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { registerThunk, clearError } from './authSlice';

const businessTypes = [
  { value: 'clothing', label: 'Clothing Store' },
  { value: 'garment', label: 'Garment Factory' },
  { value: 'medical', label: 'Medical Store' },
  { value: 'karyana', label: 'Karyana Store' },
  { value: 'cosmetics', label: 'Cosmetics Store' },
  { value: 'mobile', label: 'Mobile Shop' },
  { value: 'general', label: 'General Store' },
];

export default function RegisterPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(s => s.auth);
  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: { businessType: 'general' } });

  const onSubmit = async (data) => {
    const result = await dispatch(registerThunk(data));
    if (registerThunk.fulfilled.match(result)) navigate('/login', { state: { message: 'Registration successful! Please login.' } });
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Card sx={{ maxWidth: 480, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, bgcolor: 'primary.main', borderRadius: 3, mb: 2 }}>
              <PointOfSale sx={{ color: 'white', fontSize: 28 }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>Register Your Business</Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>Start your 14-day free trial</Typography>
          </Box>

          {error && <Alert severity="error" onClose={() => dispatch(clearError())} sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <TextField fullWidth label={t('auth.businessName')} margin="normal" error={!!errors.businessName} helperText={errors.businessName?.message}
              {...register('businessName', { required: 'Business name is required' })} />
            <TextField fullWidth select label={t('auth.businessType')} margin="normal" defaultValue="general"
              {...register('businessType')}>
              {businessTypes.map(bt => <MenuItem key={bt.value} value={bt.value}>{bt.label}</MenuItem>)}
            </TextField>
            <TextField fullWidth label={t('auth.email')} margin="normal" error={!!errors.email} helperText={errors.email?.message}
              {...register('email', { required: 'Email is required', pattern: { value: /^\S+@\S+$/i, message: 'Invalid email' } })} />
            <TextField fullWidth label="Phone (Optional)" margin="normal" {...register('phone')} />
            <TextField fullWidth label={t('auth.password')} margin="normal" type="password" error={!!errors.password} helperText={errors.password?.message}
              {...register('password', { required: 'Password is required', minLength: { value: 8, message: 'Min 8 characters' } })} />

            <Button fullWidth variant="contained" type="submit" disabled={loading} size="large" sx={{ py: 1.5, mt: 2 }}>
              {loading ? t('common.loading') : 'Start Free Trial'}
            </Button>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {t('auth.alreadyHaveAccount')}{' '}
              <Link component={RouterLink} to="/login" fontWeight={600}>{t('auth.login')}</Link>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
